export default "__VITE_ASSET__0206315f__"